<template>
    <div>
        <v-card flat>
            <v-card-text>
                <v-layout row wrap class="ma-0 pa-0">
                    <v-flex xs12 v-if="tblDataFilters.length>0" class="ma-0 pa-0">
                        <span><strong>{{heading}}</strong></span>
                        <span v-for="(category,i) in tblDataFilters" :key="`category.categoryName-${i}`">
                                <strong class="indigo--text text--darken-4"> {{ category.categoryName }} :</strong>
                                <span v-for="(keyval,j) in category.keyValues" :key="`keyval.itemName-${j}`">
                                    <span v-if="j > 0"> / </span>
                                    <span class="categoriesItemValueText"> {{keyval.itemName}}</span>
                                </span>
                        </span>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
    export default {
        props: ['tblDataFilters', 'heading'],
        data() {
            return {
            };
        },
        methods: {
            checkIfKeyValueSelected(category) {
                var selected = 0;
                for (var i = 0; i < this.tblDataFilters.length; i++) {
                    var keyvalarr = this.tblDataFilters[i];
                    if (category!=null && keyvalarr.categoryName != category) continue;
                    for (var j = 0; j < keyvalarr.keyValues.length; j++) {
                        var keyval = keyvalarr.keyValues[j];
                        if (keyval.isSelected) {
                            selected++;
                        }
                    }
                }

                /*for (var i = 0; i < this.tblDataFilters.length; i++) {
                    var selvalyd = this.tblDataFilters[i];
                   
                    for (var j = 0; j < selvalyd.length; j++) {
                        var catsel = selvalyd[j];
                        if (category != null && catsel.CategoryId != category) continue;
                        for (var k = 0; k < catsel.keyValues.length; k++) {
                            var keyval = catsel.keyValues[k];
                            if (keyval.isSelected) {
                                selected++;
                            }
                        }
                    }
                }*/

                if (selected > 0) return true;
                else return false;
            },
        }
    };
</script>
<style scoped>
</style>